(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
// Read the widget's own live data; its merchant-written caption can be outdated.
if (!customElements.get('sp-review-summary')) {
  customElements.define('sp-review-summary', class extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.sp-community');
      const nav = section.querySelector('.sp-review-nav');
      this.onNavigate = event => {
        const button = event.target.closest('[data-review-direction]');
        if (button) section.querySelector(`.jdgm-carousel__${button.dataset.reviewDirection}-arrow`)?.click();
      };
      nav?.addEventListener('click', this.onNavigate);
      const update = () => {
        const arrows = section.querySelectorAll('.jdgm-carousel__left-arrow,.jdgm-carousel__right-arrow');
        if (nav && arrows.length === 2) {
          nav.hidden = false;
          section.classList.add('sp-review-nav-ready');
          arrows.forEach(arrow => { if (arrow.tabIndex !== -1) arrow.tabIndex = -1; });
        }
        const count = Number(section.querySelector('[data-number-of-reviews]')?.dataset.numberOfReviews);
        const score = Number(section.querySelector('[data-score]')?.dataset.score);
        if (!count || !score) return;
        const text = `${score.toLocaleString('de-DE', {maximumFractionDigits:2})} / 5 aus ${count.toLocaleString('de-DE')} Produktbewertungen`;
        if (this.textContent !== text) this.textContent = text;
      };
      update();
      this.observer = new MutationObserver(update);
      this.observer.observe(section, {childList:true,subtree:true,attributes:true,attributeFilter:['data-score','data-number-of-reviews']});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.closest('.sp-community')?.querySelector('.sp-review-nav')?.removeEventListener('click', this.onNavigate);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-product-labels"] && !Shopify.designMode) return;
  try {
    
if(!window.spBrandsControlsReady){
  window.spBrandsControlsReady=true;
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-brands-prev],[data-brands-next]');
    if(!button)return;
    const track=document.getElementById(button.getAttribute('aria-controls'));
    track.scrollBy({left:track.clientWidth*(button.hasAttribute('data-brands-prev')?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  document.addEventListener('shopify:block:select',event=>{
    if(event.target.closest('[data-sp-brands] .sp-brands-carousel'))event.target.scrollIntoView({block:'nearest',inline:'nearest'});
  });
}

  } catch(e) { console.error(e); }
})();
})();
